import axios from 'axios';

const apiBase =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${apiBase}/api`,
  timeout: 15000,
});

// Injetar token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('waflow_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirecionar para login se 401
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('waflow_token');
      localStorage.removeItem('waflow_admin');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
